import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const Row = ({ label, ok, children }) => (
  <div className="rounded-lg border p-3 text-sm"><div className="flex items-center justify-between"><b>{label}</b>
    {ok !== undefined && <span className={`text-xs font-bold ${ok ? "text-emerald-600" : "text-red-600"}`}>{ok ? "VALID" : "ISSUES"}</span>}</div>{children}</div>);

export function PageCheckDialog({ item, onClose }) {
  const [r, setR] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.post(`/admin/merchant/products/${item.id}/check-page`).then((x) => setR(x.data)).catch((e) => setErr(e.response?.data?.detail || "Check failed")); }, [item.id]);
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="gmc-page-check">
        <DialogHeader><DialogTitle>Live page check — {item.sku}</DialogTitle>
          <DialogDescription>Fetches the real server HTML (no JavaScript). A valid schema doesn't guarantee Google shows a rich result.</DialogDescription></DialogHeader>
        {err && <p className="text-red-600 text-sm">{err}</p>}
        {!r && !err && <p className="text-sm text-muted-foreground">Fetching {item.attrs.link}…</p>}
        {r && <div className="space-y-2">
          <a href={r.url} target="_blank" rel="noreferrer" className="text-xs underline break-all">{r.url}</a>
          {[["plain_html", "Structured data — raw HTML"], ["googlebot", "Structured data — Googlebot render"]].map(([k, l]) => (
            <Row key={k} label={l} ok={r[k].valid}><p className="text-xs text-muted-foreground">HTTP {r[k].http} · {r[k].jsonld_blocks} JSON-LD blocks · {r[k].product_blocks} Product</p>
              {r[k].problems.map((p, i) => <p key={i} className="text-xs text-red-600">{p}</p>)}</Row>))}
          <Row label="Merchant feed" ok={r.feed.status === "eligible"}><p className="text-xs">{r.feed.status}</p>
            {r.feed.issues.filter((i) => i.severity !== "info").map((i) => <p key={i.code} className="text-xs text-amber-700">{i.message}</p>)}</Row>
          <Row label="Merchant Center approval"><p className="text-xs">{r.merchant_center}</p></Row>
          <Row label="Google Search indexing"><p className="text-xs">{r.indexing}</p></Row>
          <a className="text-xs underline" target="_blank" rel="noreferrer" href={`https://search.google.com/test/rich-results?url=${encodeURIComponent(r.url)}`} data-testid="gmc-rrt-link">Open in Google Rich Results Test</a>
        </div>}
      </DialogContent>
    </Dialog>
  );
}
